import { Component, LOCALE_ID, OnInit, Signal, inject } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoaderStoreService } from '@shared/services/loader-store.service';
import { environment } from 'src/environments/environment';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BlockUIModule } from 'primeng/blockui';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
registerLocaleData(localeEs, 'es');
export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_FORMAT_WITH_HOURS = 'dd/MM/yyyy HH:mm:ss';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports: [RouterOutlet, ProgressSpinnerModule, BlockUIModule],
    providers: [
        { provide: LOCALE_ID, useValue: 'es-ES' }, // 'es-ES' for Spanish
      ],
})
export class AppComponent implements OnInit {
    translate = inject(TranslateService);
    loaderStore = inject(LoaderStoreService);
    loading!: Signal<boolean>;
    primengConfig = inject(PrimeNGConfig);

    ngOnInit() {
        this.primengConfig.ripple = true;
        this.loading = this.loaderStore.select('loading');
        this.initLang(environment.defaultLanguage);
        this.primengConfig.setTranslation({
            dayNames:[
                'Domingo',
                'Lunes',
                'Martes',
                'Miércoles',
                'Jueves',
                'Viernes',
                'Sábado'
              ],
            dayNamesShort:['Dom', 'Lun', 'Mar', 'Mier', 'Jue', 'Vie', 'Sab'],
            dayNamesMin:['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
            monthNames:[
                'Enero',
                'Febrero',
                'Marzo',
                'Abril',
                'Mayo',
                'Junio',
                'Julio',
                'Agosto',
                'Septiembre',
                'Octubre',
                'Noviembre',
                'Diciembre'
              ],
              monthNamesShort:[
                'Ene',
                'Feb',
                'Mar',
                'Abr',
                'May',
                'Jun',
                'Jul',
                'Ago',
                'Sep',
                'Oct',
                'Nov',
                'Dic'
              ]
            //translations
        });
    }

    initLang(lang: string) {
        this.translate.setDefaultLang(lang);
        this.translate.use(lang);
    }
}
